export function siteSwitcherHtml(): string {
  return `<nav class="site-switcher" aria-label="Kalo mes nënshkrimeve dhe portalit">
    <a class="site-switcher-link active" href="https://portal.referendum21.org/" aria-current="page">Vullnetarët</a>
    <a class="site-switcher-link" href="https://referendum21.org/#nenshkruaj">Nënshkruaj</a>
  </nav>`;
}
